<script setup>
import SquareIconButton from "@/components/global-themed/buttons/SquareIconButton.vue";
import {ref, watch} from "vue";
import ScoreInfoModal from "@/components/seo-score/partials/modals/ScoreInfoModal.vue";

const showModal = ref(false);

watch(showModal, () => {
  window.mixpanel('SEO Score: Viewed Score Info');
});
</script>

<template>
  <div
    class="tw-bg-info-100 tw-border tw-border-info tw-cursor-pointer tw-rounded-xl tw-py-4 tw-px-5 tw-flex tw-justify-between tw-items-center"
    @click="showModal = true"
  >
    <span class="tw-text-base tw-text-neutral-900">
      How was this score calculated?
    </span>

    <SquareIconButton
      size="small"
      variant="info"
      class="tw-w-9"
    >
      <svg-vue
        class="tw-w-5 tw-flex-shrink-0"
        icon="icons/external-thin"
      />
    </SquareIconButton>
  </div>

  <ScoreInfoModal
    v-if="showModal"
    @close="showModal = false"
  />
</template>
